import { render, staticRenderFns } from "./ProductsAdd.vue?vue&type=template&id=4dcae377&scoped=true"
import script from "./ProductsAdd.vue?vue&type=script&lang=js"
export * from "./ProductsAdd.vue?vue&type=script&lang=js"
import style0 from "./ProductsAdd.vue?vue&type=style&index=0&id=4dcae377&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcae377",
  null
  
)

export default component.exports